export const samplePreparationCaster = (value: string) => {
  if (value === 'NONE_REQUIRED') return 'None Required'
  if (value === 'PER_MANUFACTURERS_GUIDELINES')
    return 'Per Manufacturers Guidelines'
  if (value === 'OTHER') return 'Other'
}
